import { CallApiOptions } from './api';

export const storyListCallOptions = (params: object = {}): CallApiOptions => ({
  method: 'GET',
  endpoint: 'stories',
  params: {
    limit: 20,
    ...params,
  },
});



// WEBPACK FOOTER //
// ./src/services/storylist.services.ts